const theme = {
  color: {
    blue: '#07f',
    red: '#f62459',
    lightGrey: '#ebebeb',
    darkGrey: '#a1a1a1',
    border: '#f2f2f2',
    conTour: '#ccc',
    white: '#fff',
    black: '#1f334a',
  },
};

export default theme;
